export const PRODUCT_KEY_ALREADY_EXISTS_MESSAGE =
  "This Product Key already exists.";

export const PRODUCT_KEY_MAX_LENGTH = 255;

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isProductKeyDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("product key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function createProductKeyRules() {
  return [
    { required: true, message: "Product key is required" },
    {
      max: PRODUCT_KEY_MAX_LENGTH,
      message: `Product key must be less than or equal to ${PRODUCT_KEY_MAX_LENGTH} characters.`,
    },
  ];
}
